import React from 'react';

const NotesSection = ({ formData, handleInputChange }) => {
  return (
    <div className="border-t border-gray-200 pt-6">
      <label htmlFor="notes" className="block text-sm font-medium text-gray-900">
        Additional Notes
      </label>
      <div className="mt-2">
        <textarea
          id="notes"
          rows="3"
          value={formData.notes}
          onChange={(e) => handleInputChange('notes', e.target.value)}
          className="block w-full rounded-md px-3 py-1.5 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-cyan-600 sm:text-sm"
          placeholder="Any additional information about this crew member"
        />
      </div>
    </div>
  );
};

export default NotesSection;